export default {
  data() {
    return {
      SPEECH_recognition: null,
      SPEECH_content: '',
    };
  },
  created() {},
  methods: {
    SPEECH_start() {
      try {
        this.SPEECH_recognition = new (window.SpeechRecognition ||
          window.webkitSpeechRecognition ||
          window.mozSpeechRecognition ||
          window.msSpeechRecognition)();

        this.SPEECH_content = '';
        this.SPEECH_recognition.continuous = true;
        this.SPEECH_recognition.start();
      } catch (e) {
        console.warn(e);
      }
    },
    SPEECH_end() {
      return new Promise((resolve, reject) => {
        if (!this.SPEECH_recognition) {
          return reject();
        }

        this.SPEECH_recognition.onerror = reject;

        this.SPEECH_recognition.onresult = (event) => {
          const current = event.resultIndex;

          const transcript = event.results[current][0].transcript;

          this.SPEECH_content += transcript;
          resolve(this.SPEECH_content);
        };
        this.SPEECH_recognition.stop();
      });
    },
  },
  destroyed() {
    if (this.SPEECH_recognition) {
      this.SPEECH_recognition.abort();
      this.SPEECH_recognition = null;
    }
  },
};
